function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M76,50c0,0.7,0.7,1.3,1.6,1.3h4.8c0.9,0,1.6-0.6,1.6-1.3c0-0.7-0.7-1.3-1.6-1.3h-4.8C76.7,48.7,76,49.3,76,50z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6,48.7c-0.9,0-1.6,0.6-1.6,1.3c0,0.7,0.7,1.3,1.6,1.3h4.8c0.9,0,1.6-0.6,1.6-1.3c0-0.7-0.7-1.3-1.6-1.3H17.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.3,22.4v-4.8c0-0.9-0.6-1.6-1.3-1.6c-0.7,0-1.3,0.7-1.3,1.6v4.8c0,0.9,0.6,1.6,1.3,1.6C50.7,24,51.3,23.3,51.3,22.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50,76c-0.7,0-1.3,0.7-1.3,1.6v4.8c0,0.9,0.6,1.6,1.3,1.6c0.7,0,1.3-0.7,1.3-1.6v-4.8C51.3,76.7,50.7,76,50,76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.3,72.6c0.7-0.7,0.7-1.7,0-2.4L53.8,51.7c0.2-0.5,0.3-1,0.3-1.6c0-0.5-0.1-1-0.3-1.5l9.1-9.1c0.7-0.7,0.7-1.7,0-2.4h0   c-0.7-0.7-1.7-0.7-2.4,0l-9.1,9.1c-0.4-0.1-0.9-0.2-1.3-0.2c-2.2,0-4,1.8-4,4s1.8,4,4,4c0.4,0,0.8-0.1,1.2-0.2L70,72.6   C70.6,73.2,71.7,73.2,72.3,72.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.6,33.8c-0.6-1.3-2.2-1.6-3.2-0.6h0c-0.6,0.6-0.7,1.5-0.4,2.2C84.9,40,86,44.9,86,50c0,9.6-3.7,18.7-10.5,25.5   C68.7,82.2,59.6,86,50.1,86c-9.7,0-18.8-3.7-25.6-10.5C17.8,68.7,14,59.6,14,50c0-9.5,3.6-18.4,10.3-25.2C31,17.9,40.3,14,50,14   c7.5,0,14.7,2.3,20.7,6.5h-2c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6.7c1.1,0,2-0.9,2-2v-6.7c0-1.1-0.9-2-2-2s-2,0.9-2,2v1.7   C66.9,12.9,59,10.1,50.4,10C28.1,9.8,10,27.7,10,50c0,22.1,17.9,40,40,40c22.1,0,40.2-18.2,40-40.3C90,44,88.7,38.7,86.6,33.8z"
}));

function SvgMakeMoreMeTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeMoreMeTime);
export default __webpack_public_path__ + "static/media/MakeMoreMETime.d96eede3.svg";
export { ForwardRef as ReactComponent };